import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter, Inject, AfterViewInit, OnDestroy } from '@angular/core';
import { Name } from '../../models/name.model';

@Component({
  selector: 'olr-name',
  templateUrl: './name.component.html',
  styleUrls: ['./name.component.css']
})
export class NameComponent implements OnInit, AfterViewInit, OnDestroy {
  @Output() setName = new EventEmitter<any>();
  @Output() nameInputVerified = new EventEmitter<boolean>();
  @ViewChild('firstName', {static: true}) firstName: ElementRef;
  @ViewChild('lastName', {static: true}) lastName: ElementRef;
  isFirstNameError = false;
  isLastNameError = false;
  areFieldsValid = true;
  isFirstNameValidRegex = false;
  firstNameValidBadStrings = false;
  isLastNameValidRegex = false;
  lastNameValidBadStrings = false;
  nameErrorText = 'Please do not use special characters.';
  isVerified = true;

  constructor(
    @Inject('Window') private window: any
  ) { }

  ngOnInit(): void {
    this.validateStringAnswers();
    this.sendMessage(this.areFieldsValid)
    this.enterParticipantName(this.areFieldsValid);
  }

  ngAfterViewInit(): void {
    this.window.oneX.addElement(document.querySelector('#firstLastOlrName'));
  }
  ngOnDestroy(): void {
    this.window.oneX.removeElement(document.querySelector('#firstLastOlrName'));
  }

  enterParticipantName(fieldsAreValid: boolean): void {
    if (fieldsAreValid) {
      this.setName.emit({firstName: this.firstName.nativeElement.value, lastName: this.lastName.nativeElement.value});
    } else {
      this.setName.emit({});
    }
  }

  get isRequiredComplete(): boolean {
      return  !this.isFirstNameError && !this.isLastNameError;
    }

  setAnswerState(answer: any){
    this.window.oneX.addElement(document.querySelector('#firstLastOlrName'));
    if (answer){
      this.firstName.nativeElement.value = this.removeAccents(answer.first);
      this.lastName.nativeElement.value = this.removeAccents(answer.last);
      this.enterFirstName();
      this.enterLastName();

      setTimeout(() => {
        this.window.oneX.$('.-oneX-textfield--floating-input').trigger('change');
      }, 100);
    }
  }

  enterFirstName(): void {
    this.validateStringAnswers();
    this.isFirstNameError = !this.isFirstNameValidRegex || !this.firstNameValidBadStrings;
    this.enterParticipantName(this.areFieldsValid);
    this.sendMessage(this.areFieldsValid);
  }

  enterLastName(): void {
    this.validateStringAnswers();
    this.isLastNameError = !this.isLastNameValidRegex || !this.lastNameValidBadStrings;
    this.enterParticipantName(this.areFieldsValid);
    this.sendMessage(this.areFieldsValid);
  }

  removeAccents(originalText: string): string {
    return originalText.normalize('NFD').replace(/[\u0300-\u036f]/g, "")
  }

  removeDashApostrophe(name: string): string {
    const length = name.length;
    const doubleApostrophe = name.indexOf('\'\'');
    const spaceBeforeApostrophe = name.indexOf(' \'');
    if (name[length-1] === '-') {
      name = name.slice(0, length - 1);
    }
    if (name[0] === '-' ||
      name[0] === ' ' ||
      name[0] === '\'')  {
        name = name.slice(1);
    }
    if (doubleApostrophe !== -1) {
      name = name.slice(0, doubleApostrophe) + name.slice(doubleApostrophe + 1);
    }
    if (spaceBeforeApostrophe !== -1) {
      name = name.slice(0, spaceBeforeApostrophe) + name.slice(spaceBeforeApostrophe + 1);
    }
    return name;
  }

  sendMessage(isFieldValid: boolean): void {
      this.isVerified = isFieldValid;
      this.nameInputVerified.emit(this.isVerified);
    }

  private validateStringAnswers(): void {
    const regexString = '(?!-)(?!.*--)(?!.*-$)(?!.*-.*-)[a-zA-ZÀ-ÖØ-öø-ÿ-\\ \'\\’]{1,45}(?<!-)';
    let firstName = this.firstName.nativeElement.value;
    let lastName = this.lastName.nativeElement.value
    this.isFirstNameValidRegex = this.regexValidate(firstName, regexString) || firstName == '';
    this.firstNameValidBadStrings = !this.validateBadStrings(firstName);
    firstName = this.removeDashApostrophe(firstName);
    this.firstName.nativeElement.value = firstName;

    this.isLastNameValidRegex = this.regexValidate(lastName, regexString) || lastName == '';
    this.lastNameValidBadStrings = !this.validateBadStrings(lastName);
    lastName = this.removeDashApostrophe(lastName);
    this.lastName.nativeElement.value = lastName;
    if (!this.firstNameValidBadStrings || !this.lastNameValidBadStrings) {
      this.nameErrorText = 'Please enter a valid name. Do not use words like "and", "DBA", "AKA", "NONAME" or "UNKNOWN".';
    }
    this.areFieldsValid = this.isFirstNameValidRegex && this.isLastNameValidRegex &&
                          this.firstNameValidBadStrings && this.lastNameValidBadStrings;
  }

  private regexValidate(answer: string, regexString: string): boolean {
    const regEx = new RegExp(`^${regexString}$`);
    return regEx.test(answer);
  }

  // checks the name for the word 'and', 'DBA' or 'AKA'
  private validateBadStrings(stringToCheck: string): boolean {
    return stringToCheck.toUpperCase().includes(' AND ') ||
           stringToCheck.toUpperCase().includes(' DBA ') ||
           stringToCheck.toUpperCase().includes(' AKA ') ||
           stringToCheck.toUpperCase().startsWith('AND ') ||
           stringToCheck.toUpperCase().endsWith(' AND') ||
           stringToCheck.toUpperCase().startsWith('DBA ') ||
           stringToCheck.toUpperCase().endsWith(' DBA') ||
           stringToCheck.toUpperCase().startsWith('AKA ') ||
           stringToCheck.toUpperCase().endsWith(' AKA') ||
           stringToCheck.toUpperCase() === 'NONAME' ||
           stringToCheck.toUpperCase() === 'NO NAME' ||
           stringToCheck.toUpperCase() === 'UNKNOWN' ||
           stringToCheck.toUpperCase() === 'DON\'T KNOW';
  }

}
